module.exports = __webpack_public_path__ + "img/step6-b.1210fc96.png";